module.exports = __webpack_public_path__ + "img/coach-award-logo.1a873355.svg";